// @flow
import download from 'downloadjs';
import sanitize from 'lib/sanitize';
import type {Map} from 'immutable';

export const run = function run(args: Map<*, *>): Promise<*> {
  /**
   * This RegExp was pulled from downloadjs...
   */
  if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(window.navigator.userAgent)) {
    window.alert(
      'This feature is not yet supported in Safari.\n' +
        'For best results, please use the latest version of Google Chrome.'
    );
    return new Promise((reject, resolve) => {
      resolve();
    });
  }

  const promise = args.get('promise');
  return promise.then((response) => {
    download(response.body, sanitize.filename(args.get('filename')), response.type);
  });
};
